export default "__VITE_ASSET__CkwzfeXg__";